<template>
  <div>
    <div
      class="stepper-wrapper"
      :style="{ maxWidth }"
    >
      <div class="line-through">
        <div
          class="line-through--after"
          :style="{
            transform: `translateX(${linePosition})`,
            backgroundColor: color
          }"
        />
      </div>
      <div class="stepper">
        <div
          v-for="(step, index) in steps"
          :key="step"
          class="step"
          :style="{
            borderColor: index <= currentStep ? color : '#f3f2ee',
            backgroundColor:index < currentStep ? color : 'white',
            color: index < currentStep ? 'white' : '#f3f2ee'
          }"
          @click="$emit('stepTo', index)"
        >
          <slot v-if="currentStep > index" />
          <span v-else>{{ index + 1 }}</span>
          <span
            class="step-name is-size-6"
            :style="{
              color: index <= currentStep ? color : '#f3f2ee'
            }"
          >{{ step }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
export default {

  name: 'CustomStepper',
  // The color for the stepper outline
  props: {
    color: {
      type: String,
      default: 'green'
    },
    // The maximum width allowed for the entire stepper
    maxWidth: {
      type: String,
      default: '100%'
    },
    // The step that the user is currently viewing
    currentStep: {
      type: Number,
      default: 0
    },
    // The total number of steps involved in the stepper flow
    steps: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    // Calculate how far the animated stepper line has to move, according to
    // which step the user is currently viewing.
    linePosition () {
      if (this.currentStep >= this.steps.length) return 0
      let stepLength = Math.floor(100 / (this.steps.length - 1))
      let currentStepPosition = stepLength * this.currentStep
      return `${(currentStepPosition - 100)}%`
    }
  },
  methods: {
    // Increment the current step
    next () {
      this.currentStep++
    },
    // Decrement the current step
    prev () {
      this.currentStep--
    }
  }
}
</script>

<style lang="scss" scoped>

.stepper-wrapper {
  // width: 100%;
  position: relative;
  margin: auto;
  // max-width: 600px;
}

.stepper {
  padding: 0 10%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
}

.line-through {
  position: absolute;
  width: 80%;
  background-color: #f3f2ee;
  height: 4px;
  top: 13px;
  left: 10%;
  overflow: hidden;

  &--after {
    // content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    // background-color: green;
    transform: translateX(-100%);
    transition: transform .4s;

  }

}

.step {
  color:#a5a194;

  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid #f3f2ee;
  border-color: #f3f2ee;

  border-radius: 50%;
  background-color: white;
  z-index: 20;
  transition: all .4s;

  .step-name {
    position: absolute;
    top: 35px;
    text-align: center;
  }
  // &.active {
  //   border-color: green;
  // }

  // &.completed {
  //   border-color: green;
  //   background-color: green;
  //   color: white;
  // }
}

</style>
